var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.editable) ? _c('div', [_c('Form', {
    ref: "form",
    attrs: {
      "rules": _vm.rules
    }
  }, [_vm._l((_vm.current), function(item, index) {
    return _c('div', {
      key: index
    }, [_c('div', {
      staticStyle: {
        "display": "flex",
        "margin-bottom": "10px",
        "align-items": "center"
      }
    }, [_c('Select', {
      staticStyle: {
        "width": "100px",
        "margin-right": "10px"
      },
      on: {
        "on-change": function($event) {
          return _vm.typeChanged(item, index)
        }
      },
      model: {
        value: (item.typeStr),
        callback: function($$v) {
          _vm.$set(item, "typeStr", $$v)
        },
        expression: "item.typeStr"
      }
    }, _vm._l((_vm.types), function(type, index) {
      return _c('Option', {
        key: index,
        staticStyle: {
          "width": "100px"
        },
        attrs: {
          "value": type.name,
          "label": type.name
        }
      }, [_c('span', [_vm._v(_vm._s(type.name))])])
    }), 1), _vm._v(" "), _c('FormItem', {
      attrs: {
        "prop": 'current[' + index + '].label'
      }
    }, [_c('Input', {
      staticStyle: {
        "width": "300px",
        "margin-right": "10px",
        "font-weight": "bold"
      },
      attrs: {
        "placeholder": "请输入标题"
      },
      model: {
        value: (item.label),
        callback: function($$v) {
          _vm.$set(item, "label", $$v)
        },
        expression: "item.label"
      }
    })], 1), _vm._v(" "), _c('Checkbox', {
      model: {
        value: (item.required),
        callback: function($$v) {
          _vm.$set(item, "required", $$v)
        },
        expression: "item.required"
      }
    }, [_vm._v("必填")]), _vm._v(" "), _c('Icon', {
      staticClass: "hover opahover",
      staticStyle: {
        "color": "red",
        "font-weight": "bold",
        "font-size": "24px",
        "margin-left": "50px"
      },
      attrs: {
        "type": "md-remove-circle"
      },
      on: {
        "click": function($event) {
          return _vm.removeItem(index)
        }
      }
    }), _vm._v(" "), _c('Icon', {
      staticClass: "hover opahover",
      staticStyle: {
        "color": "#20bf64",
        "font-weight": "bold",
        "font-size": "24px",
        "margin-left": "10px"
      },
      attrs: {
        "type": "md-add-circle"
      },
      on: {
        "click": function($event) {
          return _vm.insertItem(index)
        }
      }
    })], 1), _vm._v(" "), (item.typeStr == '单选' || item.typeStr == '多选') ? _c('div', [_vm._l((item.selections), function(selection, j) {
      return _c('div', {
        key: j,
        staticStyle: {
          "display": "flex",
          "align-items": "center",
          "margin-bottom": "10px"
        }
      }, [_c('FormItem', {
        attrs: {
          "prop": 'current[' + index + '].selections[' + j + '].name'
        }
      }, [_c('Input', {
        staticStyle: {
          "width": "200px",
          "margin-left": "110px"
        },
        attrs: {
          "placeholder": "请输入选项"
        },
        model: {
          value: (selection.name),
          callback: function($$v) {
            _vm.$set(selection, "name", $$v)
          },
          expression: "selection.name"
        }
      })], 1), _vm._v(" "), _c('Icon', {
        staticClass: "hover opahover",
        staticStyle: {
          "color": "red",
          "font-weight": "bold",
          "font-size": "24px",
          "margin-left": "20px"
        },
        attrs: {
          "type": "md-remove-circle"
        },
        on: {
          "click": function($event) {
            return _vm.removeSelection(item, index, j)
          }
        }
      }), _vm._v(" "), _c('Icon', {
        staticClass: "hover opahover",
        staticStyle: {
          "color": "#20bf64",
          "font-weight": "bold",
          "font-size": "24px",
          "margin-left": "10px"
        },
        attrs: {
          "type": "md-add-circle"
        },
        on: {
          "click": function($event) {
            return _vm.insertSelection(item, index, j)
          }
        }
      })], 1)
    }), _vm._v(" "), (item.selections.length == 0) ? _c('div', {
      staticClass: "hover",
      staticStyle: {
        "color": "#20bf64",
        "font-weight": "bold",
        "display": "block"
      },
      on: {
        "click": function($event) {
          return _vm.addSelection(item, index)
        }
      }
    }, [_vm._v("增加一个选项")]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (item.typeStr == '手机号') ? _c('div', [_c('div', {
      staticStyle: {
        "color": "#aaa",
        "margin-left": "110px",
        "margin-top": "-10px",
        "margin-bottom": "10px"
      }
    }, [_vm._v("用户填写该项时，必须填11位数字")])]) : _vm._e()])
  }), _vm._v(" "), _c('div', {
    staticClass: "hover",
    staticStyle: {
      "color": "#20bf64",
      "font-weight": "bold",
      "width": "100px"
    },
    on: {
      "click": _vm.addItem
    }
  }, [_vm._v("增加一项字段")])], 2)], 1) : _c('div')])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5bacf56e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/FormItemEditor.vue
// module id = Lnip
// module chunks = 138